function normalizePublicPath(value: string): string {
  return value.replace(/\/$/, '') || '/'
}

const PUBLIC_ROUTE_PATHS = new Set<string>([
  '/mentions-legals',
  '/changelog',
  '/accessibilite',
])

export function isPublicRoutePath(path: string): boolean {
  return PUBLIC_ROUTE_PATHS.has(normalizePublicPath(path))
}
